var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { configureStore } from '@reduxjs/toolkit';
import { allInitialState, allReducer } from '../slice/__all__';
/**
 * Build new saucer store
 */
export function buildSaucerStore(options) {
    if (options === void 0) { options = {}; }
    var preloadedState = __assign(__assign({}, allInitialState), { ast: __assign(__assign({}, allInitialState.ast), options.initialAST) });
    var store = configureStore({
        reducer: allReducer,
        preloadedState: preloadedState,
    });
    return store;
}
export var defaultSaucerStore = buildSaucerStore();
